<template>
  <div v-if="excerpt !== ''">
    <hr />
    <div class="product-description" v-html="excerpt"></div>

    <button
      class="read-more"
      v-if="excerpt !== description && description.length !== 0"
      @click="openDescription()"
    >
      <i class="arrow"></i> {{ translations.readMore }}
    </button>

    <sweet-modal ref="descriptionModal">
      <div v-html="description"></div>
    </sweet-modal>
  </div>
</template>

<style lang="scss" scoped>
</style>
<script>
import SweetModal from "sweet-modal-vue/src/components/SweetModal.vue";
export default {
  name: "KaaliDescription",
  components: {
    SweetModal
  },
  props: {
    excerpt: String,
    description: String
  },
  data() {
    return {
      translations: {
        readMore: ws_vue_store.translations.read_more,
      }
    };
  },
  computed: {
  },
  methods: {
    openDescription() {
      if (this.$refs.descriptionModal) {
        this.$refs.descriptionModal.open();
      } else {
        throw new Error("Example Ref not defined: descriptionModal");
      }
    },
  }
};
</script>
